import apiClient, { transformResponse } from './client';
import { API_ENDPOINTS } from '@/utils/constants';
import type { ApiResponse, AuthResponse, SigninRequest } from '@/types';

export const authApi = {
  signin: async (data: SigninRequest) => {
    const res = await apiClient.post<ApiResponse<AuthResponse>>(
      API_ENDPOINTS.AUTH.SIGNIN,
      data,
    );
    return transformResponse(res);
  },

  refreshToken: async () => {
    const res = await apiClient.post<ApiResponse<AuthResponse>>(
      API_ENDPOINTS.AUTH.REFRESH_TOKEN,
    );
    return transformResponse(res);
  },

  logout: async () => {
    const res = await apiClient.post<ApiResponse<{ message: string }>>(
      API_ENDPOINTS.AUTH.LOGOUT,
    );
    return transformResponse(res);
  },
};
